import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    description: 'Title for the Rate Shoppers page in Settings',
    defaultMessage: 'Rate Shopper',
    id: 'oDrEyz',
  },
  subHeading: {
    description: 'First Subheading for the Rate Shoppers page in Settings',
    defaultMessage:
      'Let ShipStation select the best service for your shipments automatically. With Rate Shopper, you define which services should be compared along with any additional criteria that should be considered. You can apply a Rate Shopper Rule to each shipment individually or with Automation Rules. When enabled “Available”, your Rate Shopper Rule will be selectable from the services drop down when configuring shipments.',
    id: 'zx5NG6',
  },
  rateShopperCollectionHeading: {
    description: 'Heading for the list of rating strategies the seller has created',
    defaultMessage: 'Rate Shopper Configurations',
    id: 'F/NyMC',
  },
  available: {
    description: 'Text displayed to the user for enabling/disabling a rate shopper',
    defaultMessage: 'Available',
    id: 'mPnITL',
  },
  upsellHeader: {
    description: 'Header for the upsell banner for Rate Shopper',
    defaultMessage: 'Upgrade to customize Rate Shopper.',
    id: 'R8uRoW',
  },
  upsellSubHeader: {
    description: 'details/subheader for upselling rate shopper',
    defaultMessage: 'Add your own services, delivery times and preferences',
    id: 'roz1Dj',
  },
  upsellCTAButtonText: {
    description: 'Text for the CTA button in the upsell banner',
    defaultMessage: 'Learn More',
    id: 'YZR+LG',
  },
  closeNewShopperButtonAriaLabel: {
    description: 'Aria label for the close button in the new shopper drawer',
    defaultMessage: 'Close',
    id: 'IxqhOZ',
  },
  newShopperDrawerHeaderText: {
    description: 'Text displayed in the header of the edit shopper drawer',
    defaultMessage: 'New Rate Shopper',
    id: 'ctbU9Q',
  },
  editShopperDrawerHeaderText: {
    description: 'Text displayed in the header of the edit shopper drawer',
    defaultMessage: 'Rate Shopper',
    id: '5IvoO2',
  },
  startWithRecommendedTitle: {
    description: 'Title for start with recommended option card',
    defaultMessage: 'Start with Recommended',
    id: 'B2LNJQ',
  },
  buildFromScratchTitle: {
    description: 'Title for build from scratch option card',
    defaultMessage: 'Build from Scratch',
    id: 'm/LzG6',
  },
  startWithRecommendedInfo: {
    description: 'Info for start with recommended option card',
    defaultMessage:
      'Start your Rate Shopper with the most used ShipStation services to compare rates and save! You can still add or remove any services you wish.',
    id: 'L5LHBO',
  },
  buildFromScratchInfo: {
    description: 'Info for build from scratch option card',
    defaultMessage: 'Start with a blank slate and tailor every detail of your Rate Shopper to meet your specific needs.',
    id: '9r8wK2',
  },
  startWithRecommendedButton: {
    description: 'Button for start with recommended option card',
    defaultMessage: 'Start with Recommended',
    id: 'fQjWJC',
  },
  buildFromScratchButton: {
    description: 'Button for build from scratch option card',
    defaultMessage: 'Start from Scratch',
    id: 'qCEcd1',
  },
  closeEditShopperButtonAriaLabel: {
    description: 'Aria label for the close button in the edit shopper drawer',
    defaultMessage: 'Close',
    id: 'CV4UsW',
  },
});
